//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
import Doing from './_components/doing'
import Done from './_components/done'
import Service from '@/service'
import { getConfig } from './const'
const STATUS = {
    DOING: 'doing',
    DONE: 'done'
}
const config = {"qrcode_img": "https://cdn.vip-wifi.com/fangchan/config/pages/first_paymen/first_paymen.png"}
const path = "/first_paymen/config.json"
export default {
    mixins: [mixin],
    components: {
        Doing,
        Done
    },
    data () {
        return {
            status: STATUS.DOING,
            answered_questions: [],
            result: '',
            finish: false,
            loading: false,
            current_question: {
                qid: -1,
                content: '',
                answers: []
            },
            qrcode_img: ''
        }
    },
    mounted () {
        this.getData()
        getConfig({config, path}).then(({ qrcode_img}) => {
            this.qrcode_img = qrcode_img
        })
    },
    computed: {
        show_doing () {
            return this.status === STATUS.DOING
        }
    },
    methods: {
        resetCurrentQuestion () {
            this.current_question = {
                qid: -1,
                content: '',
                answers: []
            }
        },
        async getData () {
            const answers = this.answered_questions.map(({ qid, order }) => {
                return `${qid}:${order}`
            })
            const { question, finish, result } = await Service.verifyQualication({answers}, '购房首付比例查询')
            this.finish = finish
            this.result = result
            if (!finish) {
                this.current_question.qid = question.qid
                this.current_question.content = question.question
                this.current_question.answers = Object.keys(question.answer).map((order) => {
                    return {
                        order,
                        content: question.answer[order].value,
                        next: question.answer[order].next
                    }
                })
            }
            this.loading = false
        },
        addAnswer (answer) {
            if (this.loading) {
                return
            }
            this.loading = true
            this.resetCurrentQuestion()
            this.answered_questions.push(answer)
            this.getData()
        },
        removeAnswer (i) {
            if (this.loading) {
                return
            }
            this.loading = true
            this.resetCurrentQuestion()
            this.answered_questions.splice(i, this.answered_questions.length - i)
            this.getData()
        },
        changeStatus (status) {
            this.status = status
        },
        showResult () {
            this.changeStatus(STATUS.DONE)
        }
    }
}
